/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Resume_ListeningInputs */

const en_kindle_resume_listening = /** @type {(inputs: Kindle_Resume_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume listening`)
};

const es_kindle_resume_listening = /** @type {(inputs: Kindle_Resume_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanudar la escucha`)
};

/**
* | output |
* | --- |
* | "Resume listening" |
*
* @param {Kindle_Resume_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_resume_listening = /** @type {((inputs?: Kindle_Resume_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Resume_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_resume_listening(inputs)
	return en_kindle_resume_listening(inputs)
});